import clsx from "clsx";
import { ApprovalStatusCheckbox } from "components/SmartSurveyor/ReviewPage/ApprovalStatusCheckbox";
import { rgbToCss } from "utils/rgbToCss";
import { GroupIcon } from "../GroupIcon";
import type { ExportSelectionRowProps } from "./types";

export const ExportSelectionRow = ({
  label,
  value,
  rgb,
  iconDataUrl,
  index,
  checked,
  onToggle,
}: ExportSelectionRowProps) => {
  return (
    <li>
      <button
        type="button"
        onClick={onToggle}
        className={clsx(
          "w-full flex items-center gap-2 px-4 py-3 text-left text-sm transition-colors duration-150",
          checked ? "bg-blue-100/70 hover:bg-blue-100" : "hover:bg-gray-50/80",
        )}
      >
        {iconDataUrl !== undefined && (
          <GroupIcon dataUrl={iconDataUrl} size="lg" />
        )}
        <span className="text-xs text-gray-900 tabular-nums flex-shrink-0 text-right font-semibold">
          {index}
        </span>
        <span
          className="inline-block w-2 h-2 rounded-full flex-shrink-0 ring-1 ring-black/5"
          style={{ backgroundColor: rgbToCss(rgb) }}
        />
        <span className="flex-1 truncate text-gray-800" title={label}>
          {label}
        </span>
        <span className="text-xs text-gray-500 tabular-nums">{value}</span>
        <ApprovalStatusCheckbox checked={checked} onToggle={onToggle} />
      </button>
    </li>
  );
};
